import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const SwapDetailsContainer = styled.div `
  width: 100%;
  height: 3.7rem;
`;
export const ExchangePairs = styled(ContentLoader) `
  width: 100%;
`;
export const SendAssetIcon = styled.circle `
  cx: 1.9rem;
  cy: 2rem;

  r: 1.9rem;

  ${({ theme }) => theme.media.mobileL `
      cx: 15%;
  `};

  ${({ theme }) => theme.media.laptop `
      cx: 12%;
  `};
`;
export const RecieveAssetIcon = styled.circle `
  cx: 63%;
  cy: 2rem;

  r: 1.9rem;

  ${({ theme }) => theme.media.mobileL `
      cx: 65%;
  `};

  ${({ theme }) => theme.media.laptop `
      cx: 65%;
  `};
`;
export const SendAssetAmount = styled.rect `
  height: 1.8rem;
  width: 7rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1.2rem;
  x: 15%;
  ${({ theme }) => theme.media.mobileL `
      x: 22%;
      width: 8rem;
  `};

  ${({ theme }) => theme.media.laptop `
      height: 2rem;
      width: 9rem;
      y: 1rem;
      x: 20%;
  `};
`;
export const RecieveAssetAmount = styled.rect `
  height: 1.8rem;
  width: 7rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1.2rem;
  x: 72%;
  ${({ theme }) => theme.media.mobileL `
      x: 72%;
      width: 8rem;
  `};

  ${({ theme }) => theme.media.laptop `
      height: 2rem;
      width: 9rem;
      y: 1rem;
      x: 70%;
  `};
`;
export const ArrowIcon = styled.circle `
  cx: 49%;
  cy: 2rem;

  r: 1.4rem;

  y: 1rem;

  ${({ theme }) => theme.media.laptop `
      cx: 50%;
  `};
`;
//# sourceMappingURL=styles.js.map